import { FC, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'

import {
	Button,
	Container,
	Form,
	SpaceBetween,
	Textarea
} from '@cloudscape-design/components'

import { ApiRejectionRequest } from '../../../types/apis'
import useRejectApi from '../../../hooks/mutate/useRejectApi'
import { useNavigate } from 'react-router-dom'

interface RejectionFormProps {
	thisApiID: string
	shouldShowRejectionForm: (shouldShow: boolean) => void
}

const RejectionForm: FC<RejectionFormProps> = ({
	thisApiID,
	shouldShowRejectionForm
}) => {
	const { authState } = useOktaAuth()
	const navigate = useNavigate()
	const thisUserEmail = authState?.idToken?.claims.email as string

	const [commentText, setCommentText] = useState('')

	const { mutate: rejectApi, isLoading } = useRejectApi(thisApiID)

	const handleReject = () => {
		const rejectionRequest: ApiRejectionRequest = {
			action: 'REJECT',
			apiID: thisApiID,
			commenterID: thisUserEmail,
			comment: commentText
		}

		rejectApi(rejectionRequest, {
			onSuccess: () => {
				shouldShowRejectionForm(false)
				setCommentText('')
				window.location.reload()
				navigate(`/apis/${thisApiID}`)
			}
		})
	}

	return (
		<Form
			actions={
				<SpaceBetween direction="horizontal" size="xs">
					<Button variant="link" onClick={() => shouldShowRejectionForm(false)}>
						Cancel
					</Button>
					<Button variant="primary" loading={isLoading} onClick={handleReject}>
						Reject
					</Button>
				</SpaceBetween>
			}
		>
			<Container>
				<SpaceBetween direction="vertical" size="l">
					<Textarea
						onChange={({ detail }) => setCommentText(detail.value)}
						value={commentText}
						placeholder="Reason for rejection"
					/>
				</SpaceBetween>
			</Container>
		</Form>
	)
}

export default RejectionForm
